import useIsAuthenticated from "react-auth-kit/hooks/useIsAuthenticated";
import Home from "pages/Home";
import UserProfile from "pages/User/UserProfile";

/**
 * DefaultLanding
 *
 * When the user is authenticated, show the consolidated UserProfile page by default.
 * Otherwise, fall back to the public Home page.
 */
export default function DefaultLanding() {
  const isAuthenticated = useIsAuthenticated();
  if (isAuthenticated) {
    return <UserProfile />;
  }
  return <Home />;
}
